import React from 'react';
import { Alert, AlertDescription } from '@components/ui/alert';
import { ConfirmationModal } from '../../components/confirmation-modal';
import { injectTSDI } from '../../core/tsdi';
import { Api } from '../../core/api';
import {
    TenantDto,
    TenantPageEntrySupportDto
} from '../../core/api/TenantClient';

type Props = {
    onSuccess: () => void;
    tenant?: TenantPageEntrySupportDto | TenantDto;
    openState: [boolean, React.Dispatch<React.SetStateAction<boolean>>];
};

export const TenantDeactivateModal = ({
    onSuccess,
    tenant,
    openState: [open, setOpen]
}: Props) => {
    const { tenantClient } = injectTSDI(Api);

    const handleDeactivate = async () => {
        if (tenant) {
            await tenantClient.admin.tenantAdminControllerDeactivateTenant(
                tenant.name
            );
            onSuccess();
        }
    };
    return (
        <ConfirmationModal
            open={open}
            submitHandler={handleDeactivate}
            onModalClose={() => void setOpen(false)}
            buttonText="Deactivate"
        >
            <p className="text-lg font-semibold">
                You are about to deactivate tenant <b>{tenant?.name}</b>
            </p>
            <Alert variant="warning">
                <AlertDescription>
                    Are you sure you want to deactivate this tenant?
                </AlertDescription>
            </Alert>
        </ConfirmationModal>
    );
};
